import type React from 'react'

import type { MarkdownNodeProps } from '@/types/components/Markdown'

export const COMMON_COMPONENTS: Record<string, React.FC<MarkdownNodeProps>> = {
  a: ({ node, ...props }: MarkdownNodeProps) => (
    <a
      {...props}
      target="_blank"
      rel="noreferrer"
      // duration-150 is to ensure that multi-line links don't have jumpy opacity animations
      className="text-blue-600 dark:text-blue-400 transition-opacity duration-150 hover:underline underline-offset-2"
      // leaving this one here in case we want to use it again, it's a nice animation
      // className="text-blue-600 dark:text-blue-400 underline decoration-blue-600/30 dark:decoration-blue-400/30 hover:decoration-blue-600 dark:hover:decoration-blue-400 transition-all duration-200 break-all"
    />
  ),
  blockquote: ({ node, ...props }: MarkdownNodeProps) => (
    <blockquote
      {...props}
      className="pl-4 border-l-4 border-primary-300 dark:border-primary-600 text-primary-700 dark:text-primary-300 italic"
    />
  ),
  ul: ({ node, ...props }: MarkdownNodeProps) => (
    <ul {...props} className="pl-4 list-disc" />
  ),
  ol: ({ node, ...props }: MarkdownNodeProps) => (
    <ol {...props} className="pl-4 list-decimal" />
  ),
  h1: ({ node, ...props }: MarkdownNodeProps) => (
    <h1 {...props} className="text-xl font-bold" />
  ),
  h2: ({ node, ...props }: MarkdownNodeProps) => (
    <h2 {...props} className="text-lg font-bold" />
  ),
  h3: ({ node, ...props }: MarkdownNodeProps) => (
    <h3 {...props} className="text-base font-bold" />
  ),
  h4: ({ node, ...props }: MarkdownNodeProps) => (
    <h4 {...props} className="text-sm font-bold" />
  ),
  h5: ({ node, ...props }: MarkdownNodeProps) => (
    <h5 {...props} className="text-xs font-bold" />
  ),
  h6: ({ node, ...props }: MarkdownNodeProps) => (
    <h6 {...props} className="text-[0.8rem] font-bold" />
  ),
  table: ({ node, ...props }: MarkdownNodeProps) => (
    <table
      {...props}
      className="border-collapse border border-primary-300 dark:border-primary-700 my-2"
    />
  ),
  thead: ({ node, ...props }: MarkdownNodeProps) => (
    <thead {...props} className="bg-primary-100 dark:bg-primary-800" />
  ),
  th: ({ node, ...props }: MarkdownNodeProps) => (
    <th
      {...props}
      className="bg-primary-100 dark:bg-primary-800 border border-primary-300 dark:border-primary-700 p-2 text-start break-words font-semibold"
    />
  ),
  td: ({ node, ...props }: MarkdownNodeProps) => (
    <td
      {...props}
      className="border border-primary-300 dark:border-primary-700 p-2"
    />
  ),
  mention: ({ node, children, ...props }: MarkdownNodeProps) => {
    return (
      <span
        className="text-blue-600 america:text-red-600 dark:text-blue-400"
        {...props}
      >
        @{children}
      </span>
    )
  },
  strong: ({ node, ...props }: MarkdownNodeProps) => (
    <strong {...props} className="font-semibold" />
  ),
}
